import { motion } from "framer-motion";
import { PackageSearch } from "lucide-react";
import { useState } from "react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../../components/ui/select";
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "../../../components/ui/tabs";
import { config } from "../../../utils/config";
import { OverviewView } from "../components/overview-view";
import { SearchView } from "../components/search-view";
import { OpsFilter } from "../types";

const OPS_OPTIONS: { value: OpsFilter; label: string }[] = [
  { value: "all", label: "Todas" },
  { value: "entrego", label: "Entrego" },
  { value: "muve", label: "Muve" },
  { value: "indrive", label: "Indrive" },
];

export default function OfferTrackingPage() {
  const [tab, setTab] = useState("overview");
  const [ops, setOps] = useState<OpsFilter>("all");

  // entrego, muve e indrive vivem no mesmo banco (xama)
  const dbName = `xama_${config.stage}`;

  return (
    <div className="p-6">
      <motion.div
        className="mb-6"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4 }}
      >
        <div className="flex flex-wrap items-center justify-between gap-3">
          <div className="flex items-center gap-3">
            <div className="rounded-lg bg-primary/10 p-2">
              <PackageSearch className="h-6 w-6 text-primary" />
            </div>
            <div>
              <h1 className="text-3xl font-bold text-foreground">
                Rastreamento de Ofertas
              </h1>
              <p className="text-muted-foreground">
                Acompanhe o ciclo de vida do envio das ofertas
              </p>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <span className="text-sm font-medium text-muted-foreground">OPS</span>
            <Select value={ops} onValueChange={(v) => setOps(v as OpsFilter)}>
              <SelectTrigger className="w-40">
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                {OPS_OPTIONS.map((o) => (
                  <SelectItem key={o.value} value={o.value}>
                    {o.label}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        </div>
      </motion.div>

      <Tabs value={tab} onValueChange={setTab}>
        <TabsList className="mb-6 grid w-full max-w-md grid-cols-2">
          <TabsTrigger value="overview">Visão Geral</TabsTrigger>
          <TabsTrigger value="search">Busca Individual</TabsTrigger>
        </TabsList>

        <TabsContent value="overview">
          <OverviewView dbName={dbName} ops={ops} />
        </TabsContent>

        <TabsContent value="search">
          <SearchView dbName={dbName} ops={ops} />
        </TabsContent>
      </Tabs>
    </div>
  );
}
